import { render, staticRenderFns } from "./Sandbox.vue?vue&type=template&id=5aa7b97e&scoped=true&"
import script from "./Sandbox.vue?vue&type=script&lang=js&"
export * from "./Sandbox.vue?vue&type=script&lang=js&"
import style0 from "./Sandbox.vue?vue&type=style&index=0&id=5aa7b97e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7b97e",
  null
  
)

export default component.exports